import React from 'react';

import { Svg, useSvgColor } from '~/assets/icons/styles';

const ReplayIcon = ({ color = '', ...props }) => {
  const svgColor = useSvgColor(color);
  return (
    <Svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      svgColor={svgColor}
      {...props}
    >
      <path
        d="M5.25 13.7808C5.25 18.6133 9.16751 22.5308 14 22.5308C18.8325 22.5308 22.75 18.6133 22.75 13.7808C22.75 8.94827 18.8325 5.03076 14 5.03076"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M14.8359 2.56689L12.0268 4.82345L14.2833 7.63259"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default ReplayIcon;
